import * as Flex from '@twilio/flex-ui';

import React from 'react';
import { AMCRoot } from './AMCRoot';
class App extends React.Component {
  render() {
    const { manager, config, logger } = this.props;

    return (
      <Flex.ContextProvider manager={manager}>
        {/*AMC - DO NOT Load FlexUI <Flex.RootContainer />  Load AMC UI below*/}
        <AMCRoot manager={manager} config={config} logger={logger} />
      </Flex.ContextProvider>
    );
  }
}

export default App;
